import CustomerAI from "../../Components/AI/CustomerAI"

export default function CustomerAi(){
    return(
        <CustomerAI/>
    )
}